import useComputed from '@/hooks/use-computed'
import api from '@/services/api/sourceSystemConfig.js'
import sourceSystemApi from '@/services/api/systemConfig.js'
import { immerable } from "immer"
import { useState } from 'react'
import { orderBy } from 'lodash'
class SourceSystemConfig {

	[immerable] = true

	constructor(params) {
		this.type = params.type
		this.mapping = params.mapping
		this.auth = params.auth
		this.url = params.url
		this.dataElements = params.dataElements
		this.transform = params.transform
	}
}

const useSourceSystemConfig = (sourceSystemId) => {

	const [items, setItems] = useComputed([])
	const [rawItems, setRawItems] = useComputed([])

	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [errorMsg, setError] = useState()

	const [sourceSystemsItems, setSourceSystemsItems] = useState([])
	const [sourceSystemsFilters, setSourceSystemsFilters] = useState([])
	
	const sourceSystemData = []

	function addType(object, type) {

		if (object.data === null) {
			return
		}

		if (object.type === "MULTI") {
			let tempArray = {}
			for (const property in object.endpoints) {
				tempArray = {
					type: type,
					mapping: object.type,
					auth: object.endpoints[property].auth,
					url: object.endpoints[property].url,
					transform: object.endpoints[property].transform !== undefined ? object.endpoints[property].transform : null,
					dataElements: property
				}
				sourceSystemData.push(tempArray)
			}
		}
		else if (object.type === "SINGLE" || object.type === "DEFAULT") {
			sourceSystemData.push({
				type: type,
				mapping: object.type,
				auth: object?.endpoint?.auth,
				url: object?.endpoint?.url,
				dataElements: [],
				transform: object?.endpoint.transform !== undefined ? object.endpoint.transform : null
			})
		}
		else {
			sourceSystemData.push({ type: type, mapping: object.type })
		}
	}

	function changeType(array) {
		orderBy(array, [option => option.url, option => option.type], "asc")

		return array.reduce((previous, current) => {
			if (!previous.length) {
				previous.push({ ...current, dataElements: [current.dataElements] });
			} else {
				if (previous[previous.length - 1].url === current.url && current.mapping === "MULTI" && previous[previous.length - 1].type === current.type) {
					previous[previous.length - 1].dataElements.push(current.dataElements)
				} else {
					previous.push({ ...current, dataElements: [current.dataElements] });
				}
			}
			return previous
		}, [])

	}

	async function fetch(parameter) {
		setLoading(true)

		const [error, data] = await api.index(parameter)

		setLoading(false)

		if (error) {
			return setError(error)
		}

		setRawItems(data);
		addType(data, parameter)

		const massageData = changeType(sourceSystemData)

		if (!Array.isArray(massageData)) {
			return setError('Source system config is not an array')
		}

		const serializedData = massageData.map(entry => serialize(entry))
		const newItems = serializedData.map(dataParams => new SourceSystemConfig(dataParams))

		return setItems(newItems)
	}

	async function fetchSourceSystem(type) {
		setLoading(true)
		
		const [error, response] = await sourceSystemApi.getSourceSystemLists(type)

		if (error) {
			return setError(error?.error?.message || 'Failed to add source system')
		}

		setLoading(false)
		const filterLists = orderBy(
			response,
			["created"],
			["desc"]
		);

		return setSourceSystemsItems(filterLists)
	}

	async function fetchFilters() {
		setLoading(true)
		
		const [error, response] = await sourceSystemApi.getSourceSystemFilters()

		if (error) {
			return setError(error?.error?.message || 'Failed to get Filters for source system')
		}

		setLoading(false)

		return setSourceSystemsFilters(response)
	}

	function serialize(entry) {
		return {
			type: entry.type,
			mapping: entry.mapping,
			auth: entry.auth,
			url: entry.url,
			dataElements: entry.dataElements,
			transform: entry.transform
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error:errorMsg,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		fetchSourceSystem,
		fetchFilters,
		loading,
		setItems,
		view,
		rawItems,
		sourceSystemsItems,
		sourceSystemsFilters
	}

}

export default useSourceSystemConfig;
